import { SET_TRANSLATION } from '../action/translationActions';

const initialState = {
  FeedTranslateObject: {},
  EdiTranslateObject: {},
  RoTranslateObject: {},
  HeaderTranslateObject: {},
  ProjectInfoTranslateObject:{},
  LandingTranslateObject:{},
  PumpTranslateObject: {},
  CatridgeTranslateObject: {},
  StripperTranslateObject: {},
  ChemdoseTranslateObject: {},
  MixspiltTranslateObject: {},
  ErdTranslateObject: {},
  PWTranslateObject: {},
  TCTranslateObject: {},
  NotificationTranslateObject: {},
  HelperTranslateObject: {}
};

const translationReducer = (state = initialState, action) => {
  switch (action.type) {
  case SET_TRANSLATION:
    return {
      ...state,
      [action.payload.key]: action.payload.data
    };
  default:
    return state;
  }
};
export default translationReducer;